import { useAuth0 } from '@auth0/auth0-react';
import { Button, Grid, styled, Typography } from '@mui/material';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SimpleSnackbar from '../SnackBar/SimpleSnackbar';
import sendNotification from '../../utils/sendNotification';
import './Calendar.css';

// const useStyles = makeStyles(theme => ({
//     // root: {
//     //     margin: 'auto',
//     //     width: '100%',
//     //     maxWidth: '800px',
//     //     '& > * + *': {
//     //         marginTop: theme.spacing(2),
//     //     },
//     //     textAlign: 'center',
//     //     padding: '30px 20px 40px',
//     // },
//     // accept: {
//     //     color: green[500],
//     //     fill: green[500],
//     // },
//     // decline: {
//     //     color: red[500],
//     //     color: red[500],
//     // },
// }));

const SchoolLogoImg = styled('img')(() => ({
    width: '200px',
    height: '100%',
}));

const ItemGrid = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

//Made with the help of this tutorial https://programmingwithmosh.com/react/build-a-react-calendar-component-from-scratch/

const ViewPastDate = props => {
    let history = useHistory();
    // const classes = useStyles();

    const { getAccessTokenSilently } = useAuth0();

    const [state, setState] = useState({
        loading: true,
        booking: {},
        openSnack: false,
        snackBarMessage: '',
        snackSeverity: 'success',
    });

    const navigateToDetails = uniqueId => {
        history.push(
            history.location.pathname + '/teacher-booking/' + uniqueId
        );
    };

    useEffect(() => {
        if (props.booking.sk1 !== 'undefined') {
            console.log('sk1 = ', props.booking.sk1);
            async function fetchBooking() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });

                const response = await axios.get('/getTeacherBookings', {
                    params: {
                        'sk1': props.booking.sk1,
                    },
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    url: '/getTeacherBookings',
                    timeout: 30000,
                    headers: {
                        authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (response.status === 200) {
                    if (response.data.booking.Message.Data.length > 0) {
                        setState({
                            ...state,
                            loading: false,
                            booking: response.data.booking.Message.Data[0],
                        });
                    } else {
                        setState({
                            ...state,
                            // snackSeverity: 'error',
                            loading: false,
                            // snackBarMessage:
                            //     'Failed to get any Booking Details',
                            // openSnack: true,
                        });
                        sendNotification(
                            'error',
                            6000,
                            'Failed to get any Booking Details'
                        );
                    }
                } else {
                    setState({
                        ...state,
                        // snackSeverity: 'error',
                        loading: false,
                        // snackBarMessage: 'Failed to get Booking Details',
                        // openSnack: true,
                    });
                    sendNotification(
                        'error',
                        6000,
                        'Failed to get any Booking Details'
                    );
                }
            }
            fetchBooking();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.booking.sk1]);

    let content = <Typography variant="h1">Loading</Typography>;

    if (state.loading === true) {
        content = <Typography variant="h1">Loading</Typography>;
    } else if (state.loading === false && state.snackSeverity === 'error') {
        content = <Typography>Failed to load booking</Typography>;
    } else {
        content = (
            <Grid container>
                <ItemGrid item xs={12}>
                    <Typography variant="h1">
                        Booking {state.booking.status}
                    </Typography>
                </ItemGrid>

                <ItemGrid item xs={12} sm={6}>
                    <SchoolLogoImg
                        src={state.booking.schoolLogo}
                        alt={`${state.booking.schoolName} School Logo`}
                    />
                </ItemGrid>
                <ItemGrid item xs={12} sm={6}>
                    <Typography variant="h2" sx={{ fontWeight: '400' }}>
                        {state.booking.schoolName}
                    </Typography>
                </ItemGrid>
                <ItemGrid item xs={12}>
                    {' '}
                    <Typography variant="h4">
                        Date{': '}
                        {format(
                            parseISO(state.booking.startDate),
                            'EEEE, dd MMM yyyy'
                        )}
                    </Typography>
                </ItemGrid>
                <ItemGrid item xs={12}>
                    <Typography variant="h4">
                        Time{': '}
                        {format(parseISO(state.booking.startDate), 'HH:mma')}
                    </Typography>
                </ItemGrid>

                <ItemGrid item xs={12}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() =>
                            navigateToDetails(state.booking.uniqueId)
                        }
                    >
                        View Details
                    </Button>
                </ItemGrid>
                <ItemGrid item xs={12}>
                    <SimpleSnackbar
                        message={state.snackBarMessage}
                        open={state.openSnack}
                        severity={state.snackSeverity}
                    />
                </ItemGrid>
            </Grid>
        );
    }
    return <div>{content}</div>;
};

export default ViewPastDate;
